import * as React from 'react';

import { SentimentData } from '../../../interfaces/storyAnalysis.interface';

const SentimentDisplay: React.FC<{ data: SentimentData }> = ({ data }) => {
  // Normalize — handle both old and new API shape
  const scores = data.scores ?? data.sentiment_scores;

  if (!scores) return null;

  const { negative, neutral, positive } = scores;

  // Guard against any individual value being undefined
  if (negative === undefined || neutral === undefined || positive === undefined)
    return null;

  return (
    <div>
      <h3>Sentiment Scores</h3>
      <div className="Stack">
        <div>Negative: {negative.toFixed(3)}</div>
        <div>Neutral: {neutral.toFixed(3)}</div>
        <div>Positive: {positive.toFixed(3)}</div>
      </div>
    </div>
  );
};

export default SentimentDisplay;
